/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { privacyPolicyShow } from '../../axios/privacyPolicyShow'
import type {
	PrivacyPolicyShowError,
	PrivacyPolicyShowPathParams,
	PrivacyPolicyShowResponse,
} from '../../types/PrivacyPolicyShow'

export const privacyPolicyShowQueryKey = (organisation: PrivacyPolicyShowPathParams['organisation']) =>
	[{ url: '/organisations/:organisation/privacy-policy', params: { organisation } }] as const

export type PrivacyPolicyShowQueryKey = ReturnType<typeof privacyPolicyShowQueryKey>

/** @see backend/nexus/modules/Organisation/Http/Controllers/PrivacyPolicyController.php PrivacyPolicyController::show */
export function privacyPolicyShowQueryOptions(
	organisation: PrivacyPolicyShowPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		PrivacyPolicyShowResponse,
		AxiosError<PrivacyPolicyShowError>,
		PrivacyPolicyShowResponse,
		PrivacyPolicyShowQueryKey
	>({
		queryKey: privacyPolicyShowQueryKey(organisation),
		queryFn: ({ signal }) => privacyPolicyShow(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/PrivacyPolicyController.php PrivacyPolicyController::show */
export function usePrivacyPolicyShow<TSelectData = PrivacyPolicyShowResponse>(
	organisation: PrivacyPolicyShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					PrivacyPolicyShowResponse,
					AxiosError<PrivacyPolicyShowError>,
					TSelectData,
					PrivacyPolicyShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<PrivacyPolicyShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...privacyPolicyShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/PrivacyPolicyController.php PrivacyPolicyController::show */
export function usePrivacyPolicyShowSuspense<TSelectData = PrivacyPolicyShowResponse>(
	organisation: PrivacyPolicyShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					PrivacyPolicyShowResponse,
					AxiosError<PrivacyPolicyShowError>,
					TSelectData,
					PrivacyPolicyShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<PrivacyPolicyShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...privacyPolicyShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
